import { render, staticRenderFns } from "./SocialSharing.vue?vue&type=template&id=04f72bac&"
import script from "./SocialSharing.vue?vue&type=script&lang=js&"
export * from "./SocialSharing.vue?vue&type=script&lang=js&"
import style0 from "./SocialSharing.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports